import { Button, Dialog, DialogBody, DialogContent, DialogFooter } from '@civilgrid/ui/components';
import { useSnapshot } from 'valtio';
import store from './store';

export default function MapRequestsAlert() {
  const { alertUserForMapRequests } = useSnapshot(store) as typeof store;

  return (
    <Dialog
      open={alertUserForMapRequests}
      onOpenChange={(open) => {
        if (open === false) {
          store.setAlertUserForMapRequests(false);
        }
      }}
    >
      <DialogContent
        title="Edit Project Boundary - Map Requests"
        className="z-[110] w-auto min-w-min max-w-[75vw]"
        overlayClassName="z-[100]"
        data-testid="project-edit-geometry-map-requests-dialog"
        // Opens from the boundary editor's Confirm button, which unmounts once the save finishes.
        onCloseAutoFocus={(event) => {
          const editBoundaryButton = document.querySelector<HTMLElement>(
            '[data-testid="project-details-edit-boundary"]',
          );
          if (!editBoundaryButton) return;
          event.preventDefault();
          editBoundaryButton.focus();
        }}
      >
        <DialogBody className="text-sm">
          <div>
            A CivilGrid data specialist will contact you shortly regarding pending or completed map requests that may be
            affected by the project boundary update.
          </div>
        </DialogBody>
        <DialogFooter>
          <Button
            data-testid="project-edit-geometry-map-requests-close"
            onClick={() => {
              store.setAlertUserForMapRequests(false);
            }}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
